import React, { Component } from 'react';
import AntSteps, { StepsProps as AntStepsProps } from 'antd/lib/steps';
import classNames from 'classnames';

import styles from './Steps.module.scss';

interface StepsProps extends AntStepsProps {}

class Steps extends Component<StepsProps> {
	static Step: typeof AntSteps.Step;

	render() {
		const { children } = this.props;

		return (
			<AntSteps
				{...this.props}
				className={classNames(
					styles.steps,
					styles[`stepsCount-${Array<any>(children)[0].length}`]
				)}
			/>
		);
	}
}

Steps.Step = AntSteps.Step;

export default Steps;
